import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Blog from "../../components/home/Blog";
import Contact from "../../components/home/Contact";
import Partners from "../../components/home/Partners";
import Service from "../../components/home/Service";
import DnD from "../../components/home/DnD";
import Review from "../../components/home/Review";

const Home = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios
      .get("/api/blog")
      .then((res) => {
        if (res.data.result === "0000") setData(res.data.data);
        else
          Swal.fire({
            title: "너무 많은 요청이 들어왔습니다. 다시 시도해주세요.",
            icon: "error",
          });
      })
      .catch((e) => {
        // 개발 환경 등 API 미연결 시 조용히 무시 (블로그 영역은 빈 상태로 유지)
        console.warn("블로그 데이터를 불러오지 못했습니다.", e);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <Banner />
      <About />
      <Service />
      <Blog data={data} />
      <DnD />
      <Review />
      <Contact />
      <Partners />
    </div>
  );
};

export default Home;
